import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import { IE } from './dropdown.web.utils';

class DropdownOption extends React.PureComponent {
  handleOnChange = (event) => {
    const { item, onChange } = this.props;

    onChange(event, item);
  };

  render() {
    const {
      item,
      cssClassNames,
      isHighlighted,
      id,
      isItemRootGroup,
    } = this.props;

    const events = {
      [IE ? 'onMouseDown' : 'onClick']: isItemRootGroup
        ? null
        : this.handleOnChange,
    };

    const { label, value } = item;

    return (
      <button
        className={cssClassNames}
        data-key={value}
        title={label}
        role="option"
        aria-selected={isHighlighted}
        aria-live={isHighlighted ? 'polite' : 'off'}
        aria-controls={id}
        {...events}
      >
        {label}
      </button>
    );
  }
}

DropdownOption.propTypes = {
  item: PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  }),
  cssClassNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  isHighlighted: PropTypes.bool,
  id: PropTypes.string,
  isItemRootGroup: PropTypes.bool,
  onChange: PropTypes.func,
};

DropdownOption.defaultProps = {
  item: {
    label: '',
    value: '',
  },
  cssClassNames: '',
  isHighlighted: false,
  id: '',
  isItemRootGroup: false,
  onChange: noop,
};

export default DropdownOption;
